<template>
    <div>
        <div class="title-box">
            用户信息列表
        </div>
        <el-row :gutter="20" style="margin-left:0;">
            <!-- 部门树 -->
            <el-col :span="5" :style="{ height: treeHeight + 'px','background':'#fff','border-radius':'3px','padding-top':'20px'}">
                <el-input v-model="deptName" placeholder="请输入部门名称" prefix-icon="Search" clearable />
                <el-tree
                    ref="deptTreeRef"
                    class="mt-2"
                    node-key="id"
                    :data="deptOptions"
                    :props="{ label: 'label', children: 'children' }"
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    highlight-current
                    default-expand-all
                    @node-click="handleNodeClick"
                />
            </el-col>
            <el-col :span="19">
                <!-- 查询条件 -->
                <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
                    <el-form-item label="用户账号" prop="userName">
                        <el-input v-model="queryParams.userName" placeholder="请输入用户账号" clearable @keyup.enter="handleQuery" />
                    </el-form-item>
                    <el-form-item label="手机号码" prop="phonenumber">
                        <el-input v-model="queryParams.phonenumber" placeholder="请输入手机号码" clearable @keyup.enter="handleQuery" />
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select v-model="queryParams.status" placeholder="用户状态" clearable>
                            <el-option v-for="dict in sys_normal_disable" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-date-picker
                            v-model="dateRange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="onReset">重置</el-button>
                    </el-form-item>
                    <!-- 删除添加按钮 -->
                    <span style="position:relative;float:right;bottom:14px;">
                        <i v-hasPermi="['system:user:add']" @click="openDialog()" style="background:#C7C7C7;cursor:pointer;color:#fff;width:32px;height:32px;text-align:center;margin-top:18px;padding-top:7px;border-radius:3px" class="el-icon-plus"></i>
                        <i v-hasPermi="['system:user:remove']" @click="handleDelete()" style="background:#C7C7C7;cursor:pointer;color:#fff;width:32px;height:32px;text-align:center;margin-top:18px;margin-left:5px;padding-top:7px;border-radius:3px" class="el-icon-delete"></i>
                    </span>
                </el-form>
                
                <!-- 表格 -->
                <el-table :data="tableData" border :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}" @selection-change="handleSelectionChange" class="custom-table-header">
                    <el-table-column type="selection" width="50" align="center"/>
                    <el-table-column type="index" label="序号" width="100" align="center"/>
                    <el-table-column v-if="false" label="用户编号" align="center" prop="userId" />
                    <el-table-column label="用户账号" align="center" prop="userName" />
                    <el-table-column label="用户名称" align="center" prop="nickName" />
                    <el-table-column label="部门" align="center" prop="deptName" />
                    <el-table-column label="手机号码" align="center" prop="phonenumber" width="120" />
                    <el-table-column label="状态" align="center" width="65">
                    <template #default="scope">
                        <el-switch v-if="scope.row.isMaster !== 1" v-model="scope.row.status" active-value="0" inactive-value="1" @change="handleStatusChange(scope.row)"></el-switch>
                    </template>
                    </el-table-column>
                    <el-table-column label="创建时间" align="center" prop="createTime" width="135"/>
                    <el-table-column prop="updateTime" label="修改时间" align="center"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="210" align="center">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.isMaster !== 1" v-hasPermi="['system:user:edit']" style="color:#3083FB !important;" @click="handleUpdate(scope.row)" type="text" size="small">修改</el-button>
                            <el-button v-if="scope.row.isMaster !== 1" v-hasPermi="['system:user:remove']" style="color:#3083FB !important;" @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                            <el-button v-hasPermi="['system:user:resetPwd']" style="color:#3083FB !important;" @click="handleResetPwd(scope.row)" type="text" size="small">重置密码</el-button>
                            <el-button v-if="scope.row.isMaster !== 1" v-hasPermi="['system:user:edit']" style="color:#3083FB !important;" @click="handleAuthRole(scope.row)" type="text" size="small">分配角色</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div class="block" style="background:#fff;text-align:center;padding:20px 0;">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryParams.pageNum"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="queryParams.pageSize"
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
        
        <!-- 添加 -->
        <el-dialog :title="title" :visible.sync="dialogFormVisible" width="650px" center :close-on-click-modal="false">
            <el-form class="user-form" ref="userFormRef" :model="dialogForm" :rules="rules" label-width="70px" style="padding:0;" :inline="true">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户名称" prop="nickName">
                        <el-input v-model="dialogForm.nickName" placeholder="请输入用户名称" maxlength="30" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="归属部门" prop="deptId">
                            <TreeSelect
                                v-model="dialogForm.deptId"
                                :options="deptOptions"
                                :objMap="{ value: 'id', label: 'label', children: 'children' }"
                                node-key="id"
                                placeholder="请选择归属部门"
                                check-strictly
                                @parent-event="handleParentEvent"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="手机号码" prop="phonenumber">
                        <el-input v-model="dialogForm.phonenumber" placeholder="请输入手机号码" maxlength="11" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="邮箱" prop="email">
                        <el-input v-model="dialogForm.email" placeholder="请输入邮箱" maxlength="50" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item v-if="dialogForm.userId == undefined" label="用户账号" prop="userName">
                        <el-input v-model="dialogForm.userName" placeholder="请输入用户账号" maxlength="30" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item v-if="dialogForm.userId == undefined" label="用户密码" prop="password">
                        <el-input v-model="dialogForm.password" placeholder="请输入用户密码" type="password" maxlength="20" show-password />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户性别">
                        <el-select v-model="dialogForm.sex" placeholder="请选择">
                            <el-option v-for="dict in sys_user_sex" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"></el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态">
                            <el-radio-group v-model="dialogForm.status">
                                <el-radio v-for="dict in sys_normal_disable" :key="dict.dictValue" :label="dict.dictValue">{{ dict.dictLabel }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="角色" prop="roleIds">
                        <el-select v-model="dialogForm.roleIds" filterable multiple collapse-tags placeholder="请选择">
                            <el-option
                            v-for="item in roleOptions"
                            :key="item.roleId"
                            :label="item.roleName"
                            :value="item.roleId"
                            :disabled="item.status == '1'"
                            ></el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注">
                        <el-input v-model="dialogForm.remark" type="textarea" placeholder="请输入内容"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" style="color:#000 !important;">取 消</el-button>
                <el-button type="primary" @click="handleAdd">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 选择角色 -->
        <AssignRoles ref="selectRef" v-if="selectRoleVisible" :role-id="rowUserId" :selectRoleVisible="selectRoleVisible" @ok="handleOk" @cancel="handelCancel"/>
    </div>
</template>
<script>
import { addDateRange } from '@/utils/base';
import { Message, MessageBox} from 'element-ui'
import AssignRoles from '@/components/AssignRoles/index'
import TreeSelect from '@/components/FormComp/TreeSelect'
export default {
    components:{
        AssignRoles,
        TreeSelect
    },
    data(){
        return{
            deptName:'',
            deptOptions:[],
            sys_normal_disable:[],
            sys_user_sex:[],
            // 查询条件
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                userName: '',
                phonenumber: '',
                status: '',
                deptId: '',
                roleId: ''
            },
            multiple:false,//是否进行了多选
            dateRange:['',''],
            initPassword:'',
            total:0,
            // 添加数据
            dialogForm: {
                userId: undefined,
                deptId: undefined,
                userName: '',
                nickName: undefined,
                password: '',
                phonenumber: undefined,
                email: undefined,
                sex: undefined,
                status: '0',
                remark: '',
                // postIds: [],
                roleIds: []
            },
            rules: {
                userName: [
                { required: true, message: '用户账号不能为空', trigger: 'blur' },
                {
                    min: 2,
                    max: 20,
                    message: '用户账号长度必须介于 2 和 20 之间',
                    trigger: 'blur'
                }
                ],
                nickName: [{ required: true, message: '用户名称不能为空', trigger: 'blur' }],
                password: [
                { required: true, message: '用户密码不能为空', trigger: 'blur' },
                {
                    min: 5,
                    max: 20,
                    message: '用户密码长度必须介于 5 和 20 之间',
                    trigger: 'blur'
                },
                { pattern: /^[^<>"'|\\]+$/, message: '不能包含非法字符：< > " \' \\\ |', trigger: 'blur' }
                ],
                email: [
                {
                    type: 'email',
                    message: '请输入正确的邮箱地址',
                    trigger: ['blur', 'change']
                }
                ],
                phonenumber: [
                { required: true, message: '手机号码不能为空', trigger: 'blur' },
                {
                    pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                    message: '请输入正确的手机号码',
                    trigger: 'blur'
                }
                ],
                roleIds: [{ required: true, message: '用户角色不能为空', trigger: 'blur' }]
            },
            tableHeight:650,
            treeHeight:0,
            // 表格数据
            tableData:[],
            dialogFormVisible:false,//是否显示添加对话框
            title:"",
            roleOptions:[],
            ids:'',
            names:'',
            rowUserId:"",
            selectRoleVisible:false
        }
    },
    watch: {
      deptName(val) {
        this.$refs.deptTreeRef?.filter(val);
      }
    },
    mounted() {
        this.handleResize();
        this.getDisableDict();
        this.getSexDict();
        window.addEventListener('resize', this.handleResize);
        this.getTreeSelect();
        this.getList(); // 初始化列表数据
        this.$store.dispatch('user/getConfigKey', 'sys.user.initPassword').then((result)=>{
            if(result?.data){
                this.initPassword = result.data;
            }
        });
    },
    methods: {
        // 查询系统开关
        getDisableDict(){
            this.$store.dispatch('dict/getDict', 'sys_normal_disable').then((result)=>{
                if(result?.data){
                    this.sys_normal_disable = result.data;
                }
            });
        },
        // 查询用户性别
        getSexDict(){
            this.$store.dispatch('dict/getDict', 'sys_user_sex').then((result)=>{
                if(result?.data){
                    this.sys_user_sex = result.data;
                }
            });
        },
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-191-formH;//表单的高度会变化
            this.treeHeight = height-109;
            // 设置表格体高度
            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            if(tableBody){
                tableBody.style.height = (this.tableHeight-40)+"px";
            }
        },
        /** 查询部门下拉树结构 */
        getTreeSelect(){
            this.$store.dispatch("user/deptTreeSelect").then((result)=>{
                if(result?.data){
                    this.deptOptions = result.data;
                }
            }); 
        },
        handleParentEvent(val){
            this.dialogForm.deptId = val+"";
        },
        /** 通过条件过滤节点  */
        filterNode(value,data){
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        /** 节点单击事件 */
        handleNodeClick(data){
            this.queryParams.deptId = data.id;
            this.handleQuery();
        },
        /** 搜索按钮操作 */
        handleQuery(){
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 查询用户列表 */
        getList(){
            let params = addDateRange(this.queryParams, this.dateRange);
            this.$store.dispatch('user/listUser', params).then((result)=>{
                if(result?.rows){
                    this.tableData = result.rows;
                    this.total = result.total;
                }
                else{
                    this.tableData = [];
                    this.total = 0;
                }
            }); 
        },
        // 查询
        onSubmit() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // 重置
        onReset(){
            this.queryParams = {
                pageNum:1,
                pageSize: 10,
                name:"",
                phone:"",
                weChat:"",
                department:"",
                post:""
            }
            this.dateRange=['',''];
            this.getList();
        },
        // 重置表单数据
        reset(){
            this.dialogForm = {
                userId: undefined,
                deptId: undefined,
                userName: '',
                nickName: undefined,
                password: '',
                phonenumber: undefined,
                email: undefined,
                sex: undefined,
                status: '0',
                remark: '',
                // postIds: [],
                roleIds: []
            };
        },
        // 打开添加对话框
        openDialog(){
            this.reset();
            this.$store.dispatch('user/getUser').then(async (result)=>{
                if(result?.data){
                    let data = result.data;
                    this.dialogFormVisible = true;
                    this.title = '新增用户信息';
                    await this.initTreeData();
                    this.roleOptions = data.roles;
                    this.dialogForm.password = this.initPassword.toString();
                }
            });
        },
        /** 初始化部门数据 */
        async initTreeData(){
            // 判断部门的数据是否存在，存在不获取，不存在则获取
            if (this.deptOptions === undefined) {
                const { data } = await this.$store.dispatch('user/treeselect');
                this.deptOptions = data;
            }
        },
        // 选择
        handleSelectionChange(selection){
            this.ids = selection.map((item) => item.userId);
            this.names = selection.map((item) => item.userName);
            this.multiple = !!selection.length;
        },
        // 行修改
        handleUpdate(row) {
            this.reset();
            const userId = row?.userId || this.ids[0];
            this.$store.dispatch('user/getUser', userId).then(async (result)=>{
                if(result?.data){
                    let data = result.data;
                    this.dialogFormVisible = true;
                    this.title = '修改用户';
                    await this.initTreeData();
                    Object.assign(this.dialogForm, data.user);
                    this.roleOptions = data.roles;
                    this.dialogForm.roleIds = data.roleIds;
                    this.dialogForm.password = '';
                }
            });
        },
        // 行删除
        handleDelete(row) {
            if(!row && !this.multiple){
                Message.warning("请先选择用户！");
                return;
            }
            const userIds = row?.userId || this.ids;
            const userNames = row?.userName || this.names.join(",");
            MessageBox.confirm('是否确认删除用户账号为"' + userNames + '"的数据项？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await this.$store.dispatch('user/delUser',userIds);
                this.getList();
                Message.warning('删除成功！');
            }).catch(() => { 
                
            });
        },
        // 确认添加
        handleAdd(){
            this.$refs.userFormRef?.validate(async (valid) => {
                if (valid) {
                    if(this.dialogForm.userId){
                        await this.updateUser(this.dialogForm);
                    }
                    else{
                        await this.addUser(this.dialogForm);
                    }
                    Message.success("操作成功");
                    this.dialogFormVisible = false;
                    await this.getList();
                }
            });
        },
        // 修改保存
        async updateUser(form){
            await this.$store.dispatch('user/updateUser',form);
        },
        // 新增保存
        async addUser(form){
             await this.$store.dispatch('user/addUser',form);
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        },
        /** 用户状态修改  */
        handleStatusChange(row){
           
            let text = "";
            for(let i=0;i<this.sys_normal_disable.length;i++){
                if(row.status == this.sys_normal_disable[i].dictValue){
                    text = this.sys_normal_disable[i].dictLabel;
                    break;
                }
            }
            try {
                 MessageBox.confirm('确认要' + text + '"' + row.userName + '"用户吗?', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    await this.$store.dispatch('user/changeUserStatus',{userId:row.userId, status:row.status});
                    Message.success(text + '成功');
                }).catch(() => { 
                    row.status = row.status === '0' ? '1' : '0';      
                });
            } catch (err) {
                
            }
        },
        /** 重置密码按钮操作 */
        handleResetPwd(row){
            MessageBox.prompt('请输入"' + row.userName + '"的新密码', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                inputPattern: /^.{5,20}$/,
                inputErrorMessage: '用户密码长度必须介于 5 和 20 之间',
                inputValidator: (value) => {
                    if (/<|>|"|'|\||\\/.test(value)) {
                    return '不能包含非法字符：< > " \' \\\ |';
                    }
                }
            }).then(async ({ value }) => {
                await this.$store.dispatch('user/resetUserPwd',{userId:row.userId, password:value});
                Message.success('修改成功，新密码是：' + value);
            }).catch(() => {
                   
            });
        },
        // 打开分配角色对话框
        handleAuthRole(row){
            this.rowUserId = row.userId;
            this.selectRoleVisible = true;
        },
        // 确认分配角色，子组件emit
        handleOk(){
            this.selectRoleVisible = false;
            this.onSubmit();
        },
        // 取消分配角色，子组件emit
        handelCancel(){
            this.selectRoleVisible = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    .el-row{
        padding-bottom: 10px;
    }
    ::v-deep .el-form-item__error{
        padding-top: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    
    ::v-deep .el-dialog{
        border-radius: 5px;
    }
    ::v-deep .el-dialog__header {
        padding: 6px 19px;
        background: #B1CEF9;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }   
    ::v-deep .el-dialog__headerbtn {
        font-size: 18px;
    }
    ::v-deep .el-dialog__headerbtn {
        top: 10px;
        right: 6px;
    }
    ::v-deep .el-dialog__body {
        padding: 15px 20px;
        border-bottom: 1px solid #D5D5D5;
    }
    ::v-deep .el-form-item__label {
        font-size: 12px;
    }
    ::v-deep .el-dialog__footer {
        padding: 20px;
    }
    ::v-deep .el-table__body-wrapper{
      // height: 100%;
      overflow-y: auto;
  }
  .user-form{
    .el-input, .el-textarea{
        width: 197px;
    }
  }
</style>